<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{
                  companion_type.id
                    ? $t("companionType.form.titleEdit")
                    : $t("companionType.form.titleNew")
                }}
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span>
                        {{ $t("companionType.form.nameLabel") }}
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="companion_type.companion_type_name"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="inputUser">
                        <span class="required">*</span>
                        {{ $t("companionType.form.statusLabel") }}
                      </label>
                      <select
                        v-model="companion_type.status"
                        class="form-control"
                      >
                        <option :value="1">{{ $t("common.active") }}</option>
                        <option :value="0">{{ $t("common.inactive") }}</option>
                      </select>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>{{ $t("companionType.form.requiredFields") }}</strong>
                  </span>
                  <div class="block text-right">
                    <router-link
                      to="/companion_types"
                      class="btn btn-back mr-1"
                    >
                      <i class="fa fa-arrow-left"></i> {{ $t("common.back") }}
                    </router-link>
                    <a v-if="$hasAbility('cadastro.gerenciar')" class="btn btn-add" @click="save">
                      {{ $t("common.save") }}
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      companion_type: {
        companion_type_name: "",
        status: "1",
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "companion_types";

      if (self.companion_type.id) {
        self.companion_type._method = "PUT";
        api += "/" + self.companion_type.id;
      }

      self.$loading(true);

      axios
        .post(api, self.companion_type)
        .then((response) => {
          self.$message(
            self.$t("companionType.messages.saveSuccessTitle"),
            self.$t("companionType.messages.saveSuccessMessage"),
            "success"
          );
          self.$loading(false);
          this.$router.push("/companion_types");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanionType: function (id) {
      const self = this;
      const api = self.$store.state.api + "companion_types/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.companion_type = response.data.data[0];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getCompanionType(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    Loading,
  },
};
</script>
<style scoped>
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 255, 128, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>